import React from 'react';
import classNames from 'classnames';
import { RightOutlined, MoreOutlined } from '@ant-design/icons';
import { NewRMCard } from '../NewRMCard';
import { Text } from '../../../components';
import { ROUTE_CONFIG } from '../../../constants/routes';
import './ProjectDetailsCard.scss';

export const ProjectDetailsCard = ({
    projectName,
    currentWeek,
    totalWeeks,
    status,
    startDate,
    endDate,
    owner,
    costCenter,
    onManageClick,
    onMoreClick,
    className = '',
    ...props
}) => {
    const statusClass = status === 'active' ? 'status-active' : status === 'inactive' ? 'status-inactive' : '';
    const statusLabel = status === 'active' ? 'In Progress' : status === 'inactive' ? 'Inactive' : status || '—';

    return (
        <NewRMCard className={classNames('project-details-card', className)} showMoreIcon={false} {...props}>
            <header className="project-details-card-header">
                <div className="header-left">
                    <Text size="large" color="secondary">
                        {projectName ? `${projectName} Details` : 'Project Details'}
                    </Text>
                    {onManageClick && (
                        <Text
                            color="primaryBlue"
                            bold
                            className="project-details-card-manage-link"
                            onClick={() => onManageClick(ROUTE_CONFIG.projects.path)}
                        >
                            Manage
                            <RightOutlined />
                        </Text>
                    )}
                </div>
            </header>
            <div className="project-details-card-body">
                <div className="project-details-card-week-section">
                    <Text size="small" color="muted">
                        Week
                    </Text>
                    {currentWeek != null ? (
                        <span className="project-details-card-week-value">
                            <Text bold className="project-details-card-week-number">
                                {String(currentWeek)}
                            </Text>
                            {totalWeeks != null && (
                                <Text className="project-details-card-week-total">{` of ${totalWeeks}`}</Text>
                            )}
                        </span>
                    ) : (
                        <Text size="medLarge" color="primaryBlue" extraBold>
                            Dates needed
                        </Text>
                    )}
                </div>
                <div className="project-details-card-fields">
                    <div className="project-details-card-field">
                        <Text size="small" color="muted">
                            Status
                        </Text>
                        <Text
                            size="small"
                            color="muted"
                            extraBold
                            className={classNames('project-details-card-status', statusClass)}
                        >
                            {statusLabel}
                        </Text>
                    </div>
                    <div className="project-details-card-field">
                        <Text size="small" color="muted">
                            Start Date
                        </Text>
                        <Text size="small" color="muted" extraBold>
                            {startDate || 'Not Set'}
                        </Text>
                    </div>
                    <div className="project-details-card-field">
                        <Text size="small" color="muted">
                            End Date
                        </Text>
                        <Text size="small" color="muted" extraBold>
                            {endDate || 'Not Set'}
                        </Text>
                    </div>
                    <div className="project-details-card-field">
                        <Text size="small" color="muted">
                            Owner
                        </Text>
                        <Text size="small" color="muted" extraBold>
                            {owner || 'Not Set'}
                        </Text>
                    </div>
                    <div className="project-details-card-field">
                        <Text size="small" color="muted">
                            Cost Center
                        </Text>
                        <Text size="small" color="muted" extraBold>
                            {costCenter || 'Not Set'}
                        </Text>
                    </div>
                </div>
            </div>
        </NewRMCard>
    );
};

ProjectDetailsCard.displayName = 'ProjectDetailsCard';
